import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";

export default function PaymentCancel() {
  useEffect(() => window.scrollTo(0, 0), []);
  return (
    <div className="bg-[#04070A] min-h-screen flex flex-col" data-testid="payment-cancel-page">
      <Nav />
      <section className="flex-1 flex items-center justify-center px-6 pt-24 pb-24">
        <div className="max-w-md text-center">
          <XCircle className="w-14 h-14 text-slate-500 mx-auto" />
          <h1 className="font-display text-4xl uppercase tracking-tight mt-8">Checkout Cancelled</h1>
          <p className="text-slate-400 mt-4">No worries — you weren't charged. The club will be here when you're ready.</p>
          <Link
            to="/club"
            className="inline-block mt-8 bg-orange-500 text-[#04070A] font-mono-plex text-xs tracking-[0.2em] uppercase px-8 py-4 hover:bg-orange-600 transition-colors"
            data-testid="cancel-back-link"
          >
            Back to the Club
          </Link>
        </div>
      </section>
      <Footer />
    </div>
  );
}
